import { render } from "./TarotDetailReviews.vue?vue&type=template&id=6e4de147&scoped=true"
import script from "./TarotDetailReviews.vue?vue&type=script&lang=js"
export * from "./TarotDetailReviews.vue?vue&type=script&lang=js"

import "./TarotDetailReviews.vue?vue&type=style&index=0&id=6e4de147&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4de147"]])

export default __exports__